import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Http, Response } from "@angular/http";
import { Headers, RequestOptions } from '@angular/http';
import { PanelMember } from 'src/app/model/panel-member.model';
import { ApiService } from './api.service';
import * as _ from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PanelMemberService {
  constructor(private http: Http, private apiService: ApiService) { }
  private apiDomain = ApiService.getDomainName();
  private eventId = this.apiService.getEventId();
  
  form: FormGroup = new FormGroup({
    id: new FormControl(''),
    fullName: new FormControl('', [Validators.required, Validators.minLength(3)]),
    email: new FormControl('', [Validators.required, Validators.email]),
    mobile: new FormControl('', [Validators.required, Validators.pattern(("[1-9]\\d{9}"))]),
  });

  private handleError(error: any) {
    // console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error._body);
    }
  }

  findAll(): Promise<Array<PanelMember>> {
    const headers = new Headers({ 'Content-Type' : 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/" + this.eventId + "/panelMember/", { headers })
      .toPromise()
      .then(response => response.json() as PanelMember[])
      .catch(this.handleError);
  }

  createPanelMember(panelMember: PanelMember[]) {
    let panelHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    let dataObj = JSON.stringify(panelMember);
    return this.http.post(this.apiDomain + "/ims/api/v2/" + this.eventId + "/panelMember", dataObj, { headers: panelHeaders })
      .toPromise()
      .then(response => response.json())    //response._body
      .catch(this.handleError);
  }

  updatePanelMember(panelMember: PanelMember, panelMemberId) {
    let panelHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/panelMember/" + panelMemberId, JSON.stringify(panelMember), { headers: panelHeaders })
      .toPromise()
      .then(response => (<any>response)._body)    //response._body
      .catch(this.handleError);
  }

  deletePanelMember(id) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    const url = this.apiDomain + "/ims/api/panelMember/" + id
    return this.http.delete(url, { headers })
      .toPromise()
      .then(response => (<any>response)._body)     //response._body
      .catch(this.handleError);
  }
  populateForm(panelMember) {
    this.form.setValue(panelMember);
  }

  uploadPanelMember(filePath) {
    let panelHeaders = new Headers({ 'Content-Type': 'text/plain', "file": filePath, 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.post(this.apiDomain + "ims/api/" + this.eventId + "/panelMember/upload/", { headers: panelHeaders })
      .toPromise()
      .then(response => response.json() as PanelMember[])
      .catch(this.handleError);
  }

}
